import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/rv/upload.svg'


const _withScopeId = n => (_pushScopeId("data-v-236ed15e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "clearfix" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ant-upload-drag-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "uploadIcon"
  })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ant-upload-text" }, [
  /*#__PURE__*/_createTextVNode(" Drag and drop to upload or "),
  /*#__PURE__*/_createElementVNode("span", { class: "blueFont" }, "browse for files")
], -1))
const _hoisted_4 = { style: {"position":"relative","width":"100%"} }
const _hoisted_5 = { style: {"margin-top":"10px"} }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_upload_dragger = _resolveComponent("a-upload-dragger")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createBlock(_component_a_drawer, {
    title: _ctx.title,
    closable: true,
    visible: _ctx.isUploadVisible,
    width: "35.14%",
    onClose: _ctx.close
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_a_upload_dragger, {
          name: "file",
          multiple: true,
          showUploadList: true,
          remove: _ctx.handleRemove,
          "before-upload": _ctx.beforeUpload,
          onChange: _ctx.fileChange,
          "file-list": _ctx.fileList,
          "onUpdate:file-list": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fileList) = $event))
        }, {
          default: _withCtx(() => [
            _hoisted_2,
            _hoisted_3
          ]),
          _: 1
        }, 8, ["remove", "before-upload", "onChange", "file-list"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_a_button, {
          type: "primary",
          disabled: _ctx.fileList.length === 0,
          loading: _ctx.uploading,
          style: {"margin-top":"16px"},
          onClick: _ctx.submitFile
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.uploading ? "Uploading" : "Start Upload"), 1)
          ]),
          _: 1
        }, 8, ["disabled", "loading", "onClick"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_a_table, {
          columns: _ctx.attachmentColumns,
          pagination: false,
          dataSource: _ctx.myAttachmentData,
          rowKey: "id",
          bordered: ""
        }, {
          action: _withCtx(({ record }) => [
            _createElementVNode("a", null, [
              _createElementVNode("span", {
                class: "font_family",
                style: {"font-size":"16px"},
                onClick: ($event: any) => (_ctx.deleteAttachment(record))
              }, "Delete", 8, _hoisted_6)
            ]),
            _createElementVNode("a", null, [
              _createElementVNode("span", {
                class: "font_family m-l-20",
                style: {"font-size":"16px"},
                onClick: ($event: any) => (_ctx.downloadAttachment(record))
              }, "Download", 8, _hoisted_7)
            ])
          ]),
          _: 1
        }, 8, ["columns", "dataSource"])
      ])
    ]),
    _: 1
  }, 8, ["title", "visible", "onClose"]))
}